
if (!window.__revisionLiveSyncLoaded) {
    window.__revisionLiveSyncLoaded = true;
    (function () {
        let revisionRecordId = null;
        let revisionDebounceTimer = null;
        let isRevisionCreating = false;
        let revisionCreationPromise = null;

        function getStoredLocation() {
            try {
                return localStorage.getItem('location') || '';
            } catch (e) {
                return '';
            }
        }

        function getRevisionFormData() {
            const typeEl =
                document.getElementById('revChangeType') || document.querySelector('select[name="type_of_change"]');
            const changeTypeVal = typeEl ? typeEl.value.trim() : '';

            const detailsEl =
                document.getElementById('revDetails') || document.querySelector('textarea[name="change_details"]');
            const detailsVal = detailsEl ? detailsEl.value.trim() : '';

            const feedbackEl =
                document.getElementById('revFeedback') || document.querySelector('textarea[name="feedback"]');
            const feedbackVal = feedbackEl ? feedbackEl.value.trim() : '';

            const styleRadio = document.querySelector(
                'fieldset[name="Style"] input[type="radio"]:checked, ' +
                'fieldset[name="Sign Type"] input[type="radio"]:checked, ' +
                'fieldset[name="Variation"] input[type="radio"]:checked'
            );
            const signTypeVal = styleRadio ? styleRadio.value.trim() : '{{ product.title | escape }}';

            return {
                type_of_change: changeTypeVal,
                type_of_sign: signTypeVal,
                change_details: detailsVal,
                feedback: feedbackVal,
                payment_url: window.location.href,
                location: getStoredLocation(),
                project: 'QuickSignage',
            };
        }

        async function syncRevisionData() {
            if (isRevisionCreating && revisionCreationPromise) {
                try {
                    await revisionCreationPromise;
                } catch (e) { }
            }

            const data = getRevisionFormData();

            if (!data.type_of_change && !data.change_details && !data.feedback) {
                return;
            }

            const doFetch = async () => {
                const isUpdate = Boolean(revisionRecordId);
                const endpoint = isUpdate
                    ? 'https://webhooks.codeblue.agency/api/revision/update'
                    : 'https://webhooks.codeblue.agency/api/revision/create';

                const payload = {
                    ...data,
                    project: 'QuickSignage',
                };

                if (isUpdate && revisionRecordId) {
                    payload.record_id = revisionRecordId;
                }

                try {
                    const response = await fetch(endpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        body: JSON.stringify(payload),
                    });

                    const result = await response.json();

                    if (response.ok && result.success) {
                        if (!revisionRecordId && result.record_id) {
                            revisionRecordId = result.record_id;
                            console.log('[Revision Live Sync] Created Airtable Record ID:', revisionRecordId);
                        } else {
                            console.log('[Revision Live Sync] Updated Airtable Record ID:', revisionRecordId);
                        }
                        return result;
                    } else {
                        console.error('[Revision Live Sync Error]:', result);
                    }
                } catch (err) {
                    console.error('[Revision Live Sync Exception]:', err);
                }
            };

            const initialRecordId = revisionRecordId;
            if (!initialRecordId && !isRevisionCreating) {
                isRevisionCreating = true;
                revisionCreationPromise = doFetch().finally(() => {
                    isRevisionCreating = false;
                    revisionCreationPromise = null;
                });
                return revisionCreationPromise;
            } else {
                return doFetch();
            }
        }

        function handleRevisionLiveInput() {
            clearTimeout(revisionDebounceTimer);
            const delay = revisionRecordId ? 2000 : 500;
            revisionDebounceTimer = setTimeout(() => {
                syncRevisionData();
            }, delay);
        }

        document.addEventListener('input', (e) => {
            if (e.target && e.target.closest('#revisionModal, #revisionOverlay, #revisionForm, .revision-overlay')) {
                handleRevisionLiveInput();
            }
        });

        document.addEventListener('change', (e) => {
            if (e.target && e.target.closest('#revisionModal, #revisionOverlay, #revisionForm, .revision-overlay')) {
                handleRevisionLiveInput();
            }
        });

        // Called after a revision request is successfully submitted — flags the
        // Airtable record with sent_to_at so the backend can branch on its presence.
        window.markRevisionSentToAt = function () {
            const recordId = revisionRecordId;
            if (!recordId) return;

            try {
                fetch('https://webhooks.codeblue.agency/api/revision/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    keepalive: true,
                    body: JSON.stringify({
                        record_id: recordId,
                        sent_to_at: true,
                        location: getStoredLocation(),
                        project: 'QuickSignage'
                    })
                }).then(function (response) {
                    return response.json().catch(function () { return null; });
                }).then(function (result) {
                    console.log('[Revision Live Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
                }).catch(function (err) {
                    console.error('[Revision Live Sync sent_to_at Exception]:', err);
                });
            } catch (err) {
                console.error('[Revision Live Sync sent_to_at Exception]:', err);
            }
        };

        window.resetRevisionLiveSync = function () {
            revisionRecordId = null;
            clearTimeout(revisionDebounceTimer);
        };


        // Called on modal close: stops any further syncing immediately, then
        // sends a final "complete" signal for the record created during this
        // session (if any) so Airtable reflects a finished session rather than
        // a silently abandoned one.
        window.finalizeRevisionSession = async function () {
            clearTimeout(revisionDebounceTimer);

            if (isRevisionCreating && revisionCreationPromise) {
                try { await revisionCreationPromise; } catch (e) { }
            }

            const recordIdToFinalize = revisionRecordId;
            if (recordIdToFinalize) {
                try {
                    const response = await fetch('https://webhooks.codeblue.agency/api/revision/update', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Accept: 'application/json',
                        },
                        keepalive: true,
                        body: JSON.stringify({
                            record_id: recordIdToFinalize,
                            status: 'Completed',
                            location: getStoredLocation(),
                            project: 'QuickSignage',
                        }),
                    });
                    const result = await response.json();
                    if (response.ok && result.success) {
                        console.log('[Revision Live Sync] Finalized Airtable Record ID:', recordIdToFinalize);
                    } else {
                        console.error('[Revision Live Sync Error] Finalize failed:', result);
                    }
                } catch (err) {
                    console.error('[Revision Live Sync Exception] Finalize failed:', err);
                }
            }

            revisionRecordId = null;
        };
    })();
}